
























































































































































import { ONE_MINUTE_IN_SECONDS } from '@/utils/format/date';
import { State } from 'vuex-class';
import OrderProductList from './components/OrderProductList.vue';
import RouteToPlacePopup from '@/components/ui/popups/takeAway/RouteToPlacePopup/index.vue';
import PopupWrapper from '@/components/ui/PopupWrapper/index.vue';
import QRCodeViewPopup from '@/components/ui/popups/takeAway/QRCodeViewPopup/index.vue';
import getPopupController from '@/lib/vuePopup';
import { PopupControllerPublicProperties } from '@/lib/vuePopup/interfaces';
import OrderStaff from '@/models/orderStaff';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { MutationPayload } from 'vuex';

@Component({
  name: 'ActiveOrderViewPopup',
  components: {
    PopupWrapper,
    OrderProductList,
  }
})
export default class ActiveOrderViewPopup extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  private order!: any;

  private popupController: PopupControllerPublicProperties = getPopupController();

  @State('user', {
    namespace: 'user'
  })
  private user!: any;

  private get cost(): string {
    if (this.order.totalSpent === 0) {
      return 'Бесплатно';
    }

    return `${this.order.totalSpent} ${this.order.place.currency}`;
  }

  private get minutesToEnd() {
    const secondsToEnd = this.order.datetime - this.utcNowInSeconds;

    if (secondsToEnd <= ONE_MINUTE_IN_SECONDS) {
      return 0;
    }

    return Math.floor(secondsToEnd / ONE_MINUTE_IN_SECONDS);
  }

  @State('utcNowInSeconds', {
    namespace: 'timer'
  })
  utcNowInSeconds!: number;

  private created() {
    const unsubscribe = this.$store.subscribe(({ type, payload }: MutationPayload) => {
      if ('orderHistory/doneOrder' === type && payload === this.order.id) {
        this.order.isDone = true;
      } else if ('orderHistory/undoneOrder' === type && payload === this.order.id) {
        this.order.isDone = false;
      } else if ('orderHistory/issueOrder' === type && payload === this.order.id) {
        this.order.isArchive = true;
      } else if ('orderHistory/issueAndPayOrder' === type && payload.id === this.order.id) {
        this.order.isArchive = true;
        this.order.typeOfPayment = payload.typeOfPayment;
      } else if ('orderHistory/chancelOrder' === type && payload === this.order.id) {
        this.order.isArchive = false;
      } else if ('orderHistory/takeOrder' === type && payload.id === this.order.id) {
        this.order.isCooking = true;
        this.order.staff = new OrderStaff(payload.staff);
      } else if ('orderHistory/refuseOrder' === type && payload === this.order.id) {
        this.order.isCooking = false;
        this.order.staff = null;
      } else if ('orderHistory/addReviewToOrder' === type && payload.orderId === this.order.id) {
        this.order.review = payload.review;
      }
    });

    this.$on('hook:beforeDestroy', unsubscribe);
  }

  private openRouteToPlacePopup() {
    this.popupController.createPopup(RouteToPlacePopup, {
      propsData: {
        place: this.order.place,
      }
    });
  }

  private openQRCodeViewPopup() {
    this.popupController.createPopup(QRCodeViewPopup, {
      propsData: {
        order: this.order
      }
    });
  }

  private close() {
    this.$destroy();
  }
}
